<template>
    <section class="esesja-modal">
        <form class="esesja-modal__wraper" @submit="(e) => e.preventDefault()">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.email.send-email')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeEmail');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">

                <UserAccountEmailSettingsInfo/>

                <section>
                    <label class="esesja-modal__wraper__body__label">{{$t('com.file.nav-data.contacts')}}</label>
                    <Multiselect ref="searchUsers"
                                 v-model="value"
                                 mode="tags"
                                 :placeholder="$t('com.global.search')"
                                 :close-on-select="false"
                                 :searchable="true"
                                 class="multiselect-green"
                                 :noResultsText="$t('com.global.no-results')"
                                 :noOptionsText="$t('com.global.no-options')"
                                 :groups="true"
                                 :options="availableOptions"
                                 :searchFilter="customSearchFilter"
                                 @select="selectedOptions"
                                 @click="setInputFocus">
                                 <template #tag="{ option, handleTagRemove, disabled  }">
                                    <MultiselectPersonTag :option="option" :disabled="disabled" @click="handleTagRemove(option, $event)" />
                                </template>
                    </Multiselect>

                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.send-meeting-regarding.topic-label')}}</label>
                <section class="esesja-modal__row">
                    <input class="esesja-modal__wraper__body__input" v-model="subject" :placecholder="$t('com.file.send-meeting-regarding.topic-label')" />
                </section>
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.announcements.content')}}</label>
                <section class="esesja-modal__row">
                    <textarea class="esesja-modal__wraper__body__wyswig" v-model="email"></textarea>
                </section>
                <section class="esesja-modal__row">
                    <div class="email-errors" v-if="errors.length > 0">
                        <h5 class="esesja-modal__wraper__body__label">
                            {{$t('com.validation-error.errors')}}
                        </h5>
                        <div>
                            <ul>
                                <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                            </ul>
                        </div>
                    </div>

                    <h5 class="esesja-modal__wraper__body__label">
                        <button class="upload-btn" @click="addFile()" style="float:right">+ {{$t('com.file.agenda-item-context-menu.add-attachment')}}</button>
                        {{$t('com.file.send-meeting-regarding.files-label')}}
                    </h5>
                    <div v-if="files != null && files.length > 0">
                        <ul class="esesja-modal__wraper__body__labelFile" v-for="(item, index) in files" :key="index">
                            <li>
                                {{item.name}} <v-btn icon @click="deleteFile(item)">
                                    <img src="../../../../../assets/icons/components/bin.svg" />
                                </v-btn>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <ul class="esesja-modal__wraper__body__labelFile">
                            <li>{{$t('com.send-email.no-files')}}...</li>
                        </ul>
                    </div>
                    <label class="esesja-modal__wraper__body__labelFile">*PDF, DOC, DOCX, JPG, PNG</label>
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button" @click="this.$emit('closeEmail')"> {{$t('com.global.cancel')}}</button>
                    <button class="esesja-modal__wraper__body__bottom-button esesja-modal__wraper__body__bottom-button--red" @click="sendMessage()" :disabled="value.length == 0 || email.length == 0">{{$t('com.global.send')}}</button>
                </section>
            </perfect-scrollbar>
        </form>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script charset="utf-8">
    import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
    import UserAccountEmailSettingsInfo from "../../../../Shared/Users/UserAccountEmailSettingsInfo.vue";
    import Multiselect from '@vueform/multiselect'
    import ContactService from "../../../../../services/contact.service";
    import MultiselectPersonTag from "../../../../BasicControls/Multiselect/MultiselectPersonTag.vue"
    //import AlertHelper from '@/helpers/alerts.helper.js';

    export default {
        name: "SendEmail",
        data() {
            return {
                name: "",
                isLoading: false,
                count: 0,
                email: "",
                value: [...this.selected],
                files: [],
                subject: "",
                errors: []
            };
        },
        props: {
            options: Array,
            selected: Array
        },
        components: {
            LoaderInside,
            Multiselect,
            UserAccountEmailSettingsInfo,
            MultiselectPersonTag
        },
        computed: {
            availableOptions() {
                return this.options.map(item => ({
                    id: item.id,
                    label: item.label,
                    options: item.options.map(opt => ({
                        value: opt.value,
                        label: opt.label,
                        groupId: item.id
                    }))
                }));
            }
        },
        methods: {
            customSearchFilter(option, query) {
                let localQuery = query.toUpperCase();
                let localcopy = [...this.availableOptions];
                // check if any groups meets criteria
                let filterGroup = localcopy.filter(item => {
                    let copyGroupLabel = item.label.toUpperCase()
                    return copyGroupLabel.includes(localQuery);
                })

                if (filterGroup.length > 0) {
                    let isOptionIsInGroup = filterGroup.filter(item => item.id === option.groupId);
                    return isOptionIsInGroup.length > 0;
                }
                return option.label.toUpperCase().includes(localQuery);
            },
            selectedOptions() {
                this.$refs.searchUsers.clearSearch();
            },
            setInputFocus(){
                const input = this.$refs.searchUsers.$el.querySelector("input");
                if(input)
                    input.focus();
            },
            async sendMessage() {
                try {
                    this.isLoading = true;
                    let formData = new FormData();
                    for (var i = 0; i < this.files.length; i++) {
                        let file = this.files[i];
                        formData.append('files[' + i + ']', file);
                    }

                    formData.append("msg", this.email);
                    formData.append("subject", this.subject);
                    formData.append("ids", this.value);

                    var result = (await ContactService.sendEmailToUsers(formData));
                    if (result.status == 200) {
                        this.value = [];
                        this.email = "";
                        this.files = [];
                        this.$emit("closeEmail");
                        this.$store.commit('setSendMessageSuccess', true);
                        this.$store.commit('setSelectedPeopleToSendMessage', []);
                    }
                } catch (e) {
                    if (e.response.status == 401)
                        this.$router.push({ name: 'Login' })
                }
                finally{
                    this.isLoading = false;
                }
            },
            addFile() {
                let input = document.createElement('input');
                input.type = 'file';
                input.accept = '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.png,.jpg,.jpeg';
                input.multiple = true;
                input.click();
                input.addEventListener('change', async (event) => {
                    this.errors = [];
                    for (let item of event.target.files) {
                        if (item.size > 25000000) {
                            this.errors.push(this.$t('com.validation-error.invalid-file-size-info') + ` 25MB`);
                            continue;
                        }

                        if (this.checkMimeType(item.type) === false) {
                            this.errors.push(this.$t('com.validation-error.invalid-file-type-info') + ` DOC,DOCX,PDF,JPG,JPEG,PNG`);
                            continue;
                        }

                        if(this.files.find(obj => obj.name === item.name)){
                            continue;
                        }
                        this.files.push(item);
                    }

                });
            },
            checkMimeType(type) {
                if (type != "application/pdf" && type != "image/jpeg" && type != "image/jpg" &&
                    type != "image/png" && type != "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
                    type != "text/plain" && type != "application/msword") {
                    return false;
                } else {
                    return true;
                }
            },
            deleteFile(item) {
                this.files = this.files.filter(obj => obj.name !== item.name);
            },
        },
        mounted() {
        
        },
    };
</script>
<style lang="scss" scoped>
    @use "../../../../../assets/scss/esesja-modal.scss";
    @use "../../../../../assets/scss/multiselect-modal.scss";

    .email-errors {
        border: 1px solid red;
        background: rgba(255, 0, 0, 0.3);
        padding: 10px;
        margin-bottom: 10px;
    }

    .multiselect-green {
        --ms-tag-bg: #D1FAE5;
        --ms-tag-color: #059669;
    }

    ::v-deep(.multiselect-tags){
        column-gap: 7.5px;
        row-gap: 7.5px;
        max-height: 200px; 
        overflow: hidden; 
        scroll-behavior: smooth; 
        overflow-y: auto; 
    }

    ::v-deep(.multiselect-tags > .multiselect-tags-search-wrapper){
        order: -1;
        flex-basis: 100%;
    }

    .upload-btn {
        display: flex;
        align-items: center;
        border: 0px;
        padding: 5px 5px;
        background: rgba(220, 228, 238, 0.56);
        border-radius: 4px;
    }
</style>